import * as Noibu from "noibu-vue";
import { noibuTrackingConsent } from "~/utils/errorLoggerUtils";

export default defineNuxtPlugin((nuxtApp) => {
  // Check for existing error handler
  nuxtApp.vueApp.config.errorHandler = (_err) => {};

  const noibuScript = useScript(
    {
      id: "noibu-script",
      src: "https://cdn.noibu.com/collect.js",
      defer: true,
      referrerpolicy: "strict-origin-when-cross-origin",
      fetchpriority: "low",
      tagPriority: "low",
    },
    {
      trigger: noibuTrackingConsent,
      warmupStrategy: false,
    }
  );

  noibuScript.onLoaded(() => {
    try {
      // @reference: https://help.noibu.com/hc/en-us/articles/9565275187341-Noibu-Vue-SDK
      // Initialize Noibu SDK: Throws an error when trying to initialize the SDK without either the vue param or the apps param.
      Noibu.initNoibuSDK({ apps: [nuxtApp.vueApp] });

      const authStore = useAuthStore();
      const { user, guest } = storeToRefs(authStore);

      const customerId = user.value?.id
        ? user.value.id
        : guest.value?.id
        ? guest.value.id
        : null;

      const runtimeConfig = useRuntimeConfig();
      const siteVersion = runtimeConfig.public.version;

      checkSDKExistenceAndAddCustomAttribute("customerID", customerId);
      checkSDKExistenceAndAddCustomAttribute("version", siteVersion);
    } catch (noibuSdkError) {
      console.error("Noibu SDK Init Error:", noibuSdkError);
    }
  });
});

async function checkSDKExistenceAndAddCustomAttribute(attributeName, value) {
  if (!window.NOIBUJS) {
    await new Promise((resolve) => {
      window.addEventListener("noibuSDKReady", resolve);
    });
  }
  window.NOIBUJS.addCustomAttribute(attributeName, value);
}
